import { Map } from 'immutable';

import { clearErrors, setErrors } from '../errors';
import { getTagsError } from '../validations/tags';
import { keepOld } from '../iterable/keepOld';
import { getSize } from '../iterable/getSize';

import { NEW, OPERATIONS, VALUE } from '../../constants/product';
import { MAX_NUMBER_OF_TAGS } from '../../constants/validations';
import { EMPTY, SEPARATOR } from '../../constants';
import { ATTRIBUTE } from '../../constants/attributes';
import { FORM } from '../../constants/forms';

export function getTagsAndError({ channel, newTags, tags }) {
  function reduceNewTags(result, value, key) {
    if (getSize(result.allTags) >= MAX_NUMBER_OF_TAGS[channel]) return result;

    if (!result.allTags.has(key)) {
      result.allTags = result.allTags.set(key, value);
      result.updatedNewTags = result.updatedNewTags.set(key, value);
    }

    return result;
  }

  const { allTags, updatedNewTags } = newTags.reduce(
    reduceNewTags,
    { allTags: tags, updatedNewTags: EMPTY.ORDERED_MAP }
  );

  const error = getTagsError({ channel, tags: allTags });

  return { error, newTags: updatedNewTags, tags };
}

export function editTags({ newTags, operation: operationType, product: source, tagsToRemove }) {
  let product = source;
  const operations = [];
  const channel = product.get('channel');
  const productTags = product.getIn([FORM.TAGS, VALUE]);

  product = clearErrors({ errors: [ATTRIBUTE.TAGS], product });

  switch (operationType) {
    case OPERATIONS[channel].TAGS.ADD: {
      const { error, newTags: updatedNewTags } = getTagsAndError({
        channel,
        newTags,
        tags: productTags,
      });

      product = product.setIn([FORM.TAGS, NEW], updatedNewTags);

      if (error) {
        product = setErrors({ errors: Map({ [ATTRIBUTE.TAGS]: error }), product });
      } else if (getSize(updatedNewTags)) {
        operations.push(
          Map({
            type: OPERATIONS[channel].TAGS.ADD,
            value: updatedNewTags.toList().join(SEPARATOR.COMMA_SPACE),
          })
        );
      }

      break;
    }

    case OPERATIONS[channel].TAGS.DELETE: {
      if (tagsToRemove) {
        product = product.setIn([FORM.TAGS, VALUE], productTags.deleteAll(tagsToRemove.keySeq()));
        operations.push(
          Map({
            type: OPERATIONS[channel].TAGS.DELETE,
            value: tagsToRemove.toList().join(SEPARATOR.COMMA_SPACE),
          })
        );
      }

      if (getSize(newTags)) {
        const { error, newTags: updatedNewTags } = getTagsAndError({
          channel,
          newTags,
          tags: product.getIn([FORM.TAGS, VALUE]),
        });

        product = product.setIn([FORM.TAGS, NEW], updatedNewTags);

        if (error) {
          product = setErrors({ errors: Map({ [ATTRIBUTE.TAGS]: error }), product });
        } else {
          operations.push(
            Map({
              type: OPERATIONS[channel].TAGS.ADD,
              value: updatedNewTags.toList().join(SEPARATOR.COMMA_SPACE),
            })
          );
        }
      }

      break;
    }

    case OPERATIONS[channel].TAGS.CHANGE_TO: {
      if (newTags) {
        product = product.setIn([FORM.TAGS, NEW], newTags);
      }

      if (tagsToRemove) {
        const filteredTags = productTags.deleteAll(tagsToRemove.keySeq());
        product = product.setIn([FORM.TAGS, VALUE], filteredTags);
      }

      const allTags = product
        .getIn([FORM.TAGS, VALUE], EMPTY.ORDERED_MAP)
        .mergeWith(keepOld, product.getIn([FORM.TAGS, NEW]));

      const error = getTagsError({ channel, tags: allTags });

      if (error) {
        product = setErrors({ errors: Map({ [ATTRIBUTE.TAGS]: error }), product });
      } else {
        const operation = Map({ type: OPERATIONS[channel].TAGS.CHANGE_TO, value: allTags.toList() });
        operations.push(operation);
      }

      break;
    }

    default: {
      break;
    }
  }

  return { product, operations };
}
